import dynamicUi from './dynamicUi.json'
import ui from './ui.json'

export default {
  language: 'English',
  ...ui,
  ...dynamicUi
}
